var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineStarSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.11 19.38c-.4-.09-.66-.5-.56-.9l.57-2.46c.08-.32-.08-.87-.32-1.11l-2.48-2.48c-1.24-1.24-1.14-2.3-.97-2.82.17-.52.71-1.44 2.43-1.73l3.19-.53c.3-.06.73-.38.86-.65L9.6 3.17c.8-1.61 1.85-1.84 2.4-1.84.55 0 1.6.24 2.4 1.84l1.76 3.52c.06.12.19.26.34.38.33.25.39.73.13 1.05-.25.33-.72.39-1.05.13-.24-.18-.56-.49-.76-.89l-1.76-3.52c-.31-.63-.71-1.01-1.06-1.01-.35 0-.75.38-1.06 1.02L9.17 7.37c-.35.7-1.19 1.32-1.96 1.45l-3.18.53c-.68.11-1.14.38-1.25.71-.11.33.12.82.61 1.3l2.48 2.48c.6.6.91 1.68.72 2.51l-.57 2.46c-.09.35-.39.59-.74.59-.06 0-.11-.01-.17-.02zM15.6 22l-2.99-1.77c-.31-.18-.91-.18-1.21 0L8.4 22a.76.76 0 0 1-1.03-.26.758.758 0 0 1 .26-1.03l2.99-1.77c.78-.46 1.96-.46 2.74 0l2.99 1.77c.87.52 1.42.52 1.63.37.21-.15.36-.68.14-1.66l-.71-3.07c-.19-.83.12-1.9.72-2.51l2.48-2.48c.49-.49.71-.97.61-1.3-.11-.33-.57-.6-1.25-.71a.755.755 0 0 1-.62-.86c.07-.41.45-.68.86-.62 1.73.29 2.27 1.21 2.43 1.73.16.52.26 1.58-.97 2.82L19.2 14.9c-.24.24-.39.78-.32 1.11l.71 3.07c.46 2-.25 2.87-.71 3.21-.25.18-.65.38-1.22.38-.53 0-1.21-.17-2.06-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47 22.53a.754.754 0 0 1 0-1.06l20-20c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-20 20c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineStarSlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-star-slash.2f509a1f5ccbb3ece6e7567d5510b8c3.svg";
export { ForwardRef as ReactComponent };